import React from 'react';
import {
  makeStyles,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@material-ui/core"
import { useSelector } from 'react-redux';
import { DialogResponsive } from './DialogResponsive';
import WarningRounded from '@material-ui/icons/WarningRounded';
import { ImagineGrid as Grid } from '../../components'
import { useDispatch } from "react-redux"
import { userFunctionActions } from "../../actions"
import { history } from "./../../helpers"
import { useTranslation } from 'react-i18next';

const useStyle = makeStyles((theme) => ({
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  modalWrapper: {
    padding: "2rem",
    justifySelf: "center"
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  warningIcon: {
    color: theme.palette.auxiliary.yellow.main,
    fontSize: 100,
  },
  button: {
    width: "100%"
  },
  titleWrapper: {
    display: "flex",
    justifyContent: "center",
  },
  title: {
    fontWeight: 600
  },
  description: {
    textAlign: "center",
    fontSize: 16
  },
  actions: {
    padding: theme.spacing(3)
  }
}));

export const DialogCancelUser = ({ toggleEdit }) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { dialogCancelUser } = useSelector(state => state.userFunction);

  function handleNoButton() {
    dispatch(userFunctionActions.toggleDialogCancelUser())
  }

  function handleYesButton() {
    dispatch(userFunctionActions.toggleDialogCancelUser());
    toggleEdit()
  }

  return (
    <DialogResponsive open={dialogCancelUser}>
      <DialogContent className={classes.content}>
        <Grid container spacing={4}>
          <Grid item className={classes.iconWrapper}>
            <WarningRounded className={classes.warningIcon} />
          </Grid>
          <Grid item className={classes.titleWrapper}>
            <Typography variant="h4" component="h2" className={classes.title}>
              {t('atencao')}
            </Typography>
          </Grid>
          <Grid item>
            <p className={classes.description}>
              {t('todos_os_dados_informados_serao_perdidos')}. {' '}
              {t('tem_certeza_que_deseja_cancelar')}
            </p>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Grid container spacing={4} cols={2}>
          <Grid item>
            <Button
              className={classes.button}
              variant="outlined"
              color="primary"
              onClick={handleNoButton}
            >
              {t('nao')}
            </Button>
          </Grid>
          <Grid item>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              onClick={handleYesButton}
            >
              {t('sim')}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </DialogResponsive>
  )
}
